import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import withMedia from '../core/withMedia'
import EventBus from '../core/EventBus'

const STATUS = {
    OPEN: 'is-open',
    CLOSED: 'is-closed',
    ACTIVE: 'is-active',
    ACTIVE: 'is-active',
    CLOSING: 'is-closing',
}

class FooterPortfolio extends Component {
    constructor(element) {
        super(element, {
            media: 'smallWideMax',
        })

        this.ref = {
            button: null,
            body: null,
        }

        this.state = {
            portfolioHeight: null,
        }
    }

    prepare() {
        this.ref.button.addEventListener('click', this.handleButtonClick)
        this.ref.body.style.height = 0
        this.ref.body.classList.add(STATUS.CLOSED)
        this.ref.body.addEventListener('transitionend', this.handleTransitionEnd)
        EventBus.on('swup:contentreplaced', this.handleContentReplaced)
    }

    destroy() {
        EventBus.off('swup:contentreplaced', this.handleContentReplaced)
    }

    handleTransitionEnd = (event) => {
        if (event.target !== this.ref.body) {
            return
        }
        if (this.ref.body.classList.contains(STATUS.CLOSED)) {
            this.ref.button.classList.remove(STATUS.ACTIVE)
        } else {
            scrollToElement(this.element)
            this.ref.body.removeAttribute('style')
        }
    }

    handleContentReplaced = () => {
        this.close()
    }

    handleButtonClick = () => {
        this.toggle()
    }

    toggle() {
        if (this.ref.body.classList.contains(STATUS.CLOSED)) {
            this.open()
        } else {
            this.close()
        }
    }

    open() {
        this.ref.body.classList.remove(STATUS.CLOSED)
        this.ref.button.classList.add(STATUS.ACTIVE)
        this.ref.body.style.height = this.ref.body.scrollHeight + 'px'
    }

    close() {
        this.ref.body.style.height = this.ref.body.scrollHeight + 'px'
        this.ref.body.offsetHeight
        this.ref.body.classList.add(STATUS.CLOSED)
        this.ref.body.style.height = '0px'
    }
}

export default withMedia(FooterPortfolio)
